import React, { Component } from 'react';
import { Col, Card, CardBody, Row, Button, Label, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import withAuth from '../../components/Services/WithAuth';
import Modal from '../../components/UI/Modal/Modal';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import CreateMisFormFields from './CreateMisFormFields/index';
import MisFieldFilter from './MisFieldFilter/index';
import MisTableView from './MisTableView/index';
import { createMisFormField, getMisFormFieldFilteredList,getMasterData } from './action';
import { DEFAULT_REQUEST_BODY, DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, DEFAULT_SORTING } from './constants';
import { setMisFilteredRequestBody, setAppliedfilters, removeFilterValue, removeAppliedFilterData, clearAllFilter } from './helper';
class MisFormFieldComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {

            showModal: false,
            body: null,
            loading: true,
            columns: [],
            appliedFiltersList: [],
            appliedFilter: [],
            searchText: ''
        }
    }
    componentDidMount() {
        this.props.getMisFormFieldFilteredList(DEFAULT_REQUEST_BODY);
        if(!this.props.masterDataList || this.props.masterDataList.length===0)
            this.props.getMasterData();
    }

    componentDidUpdate(prevProps) {
        const { listData, createMisFormFieldSuccess, createMisFormFieldFailure } = this.props
        if (createMisFormFieldSuccess !== prevProps.createMisFormFieldSuccess) {
            toast.success(
                <div>
                    {createMisFormFieldSuccess.name} Created Successfully
                </div>
            );
            this.handleToggle();
        }
        if (createMisFormFieldFailure !== prevProps.createMisFormFieldFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{createMisFormFieldFailure.data.message}
                </div>
            );
        }
        if (listData !== prevProps.listData) {
            this.setState({
                loading: false
            })
        }
    }

    handleToggle = () => {
        this.setState((prevState) => ({
            showModal: !prevState.showModal,
            body: null
        }))
    }
    handleCreate = (data) => {
        this.props.createMisFormField(data)
    }


    handleCreateMisField = () => {
        this.setState((prevState) => ({
            showModal: !prevState.showModal, 
        }))
    }

    handleSearchText = (searchText) => {
        this.setState({
            searchText: searchText
        }, () => {
            this.onFetchPage(DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, DEFAULT_SORTING)
        })
    }
    onFetchPage = (pageNo, pageSize, sorted) => {
        const requestBody = setMisFilteredRequestBody(pageNo, pageSize, sorted, this.state.appliedFiltersList, this.state.searchText)
        this.props.getMisFormFieldFilteredList(requestBody);
    }
    handleAppliedFilters = (filterData) => {
        const tempFilterData = setAppliedfilters(filterData)
        this.setState({
            appliedFilter: filterData,
            appliedFiltersList: tempFilterData
        }, () => {
            this.onFetchPage(DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, DEFAULT_SORTING)
        })
    }

    handleRemoveFilter = (filterData, index) => {
        const tempRemoveFilter = removeFilterValue(index, this.state.appliedFiltersList);
        const tempAppliedFilter = removeAppliedFilterData(filterData, this.state.appliedFilter)
        this.setState({
            appliedFilter: tempAppliedFilter,
            appliedFiltersList: tempRemoveFilter
        }, () => {
            this.onFetchPage(DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, DEFAULT_SORTING)
        });

    }
    handleClearAll = () => {
        this.setState((prevState) => ({
            appliedFiltersList: [],
            appliedFilter: clearAllFilter(prevState.appliedFilter)
        }), () => {
            this.onFetchPage(DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, DEFAULT_SORTING)
        })
    }


    render() {
        return (
            <Col>
                <Row>
                    <Col sm='22'>
                        <h4>View All Mis Form Fields </h4>
                    </Col>
                </Row>
                <Row>
                    <Col sm='22'>
                        <MisFieldFilter searchCallback={this.handleSearchText} appliedFilterValues={this.state.appliedFilter} misFieldFiltercallback={this.handleAppliedFilters} />
                    </Col>
                    <Col sm='2'>
                        <Button className='btn create-button' color='primary' onClick={this.handleCreateMisField}>Add</Button>
                    </Col>
                </Row>
                <div className="no-gutters mb-3 d-flex flex-column flex-sm-row">
                    <Label className="filter-title col-sm-3 pr-0">Applied Filters :</Label>
                    <div className="col-sm-21 pl-0 filter d-flex flex-wrap align-items-center">
                        {this.state.appliedFiltersList.map((p, index) => {
                            return (
                                <span key={p.label} className="filter-item d-flex align-items-center mr-2 mb-2">
                                    {p.label} <i className="icon-close pointer" onClick={() => this.handleRemoveFilter(p, index)}></i>
                                </span>
                            )
                        })}
                        {(this.state.appliedFiltersList.length > 0) ? <Button className="filter-item filter-item-btn-clear" color="primary" size="xs" onClick={this.handleClearAll}>Clear All</Button> : null}
                    </div>
                </div>
                <Row>
                    <Card className='master-data-table'>
                        <CardBody>
                            <MisTableView tasks={this.props.listData} onFetchPage={this.onFetchPage} />
                        </CardBody>
                    </Card>
                </Row>
                <Modal show={this.state.showModal} className="Modal" >
                    {/* <p>Show Modal Data</p> */}
                   {/*this.state.body*/}
                   <CreateMisFormFields closeModal={this.handleToggle} createCallback={this.handleCreate} masterDataList={this.props.masterDataList} />
                </Modal>
            </Col>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    createMisFormFieldSuccess: state.misFormField.createMisFormFieldSuccess,
    createMisFormFieldFailure: state.misFormField.createMisFormFieldFailure,
    listData: state.misFormField.misFormFieldFilteredList,
    masterDataList:state.misFormField.masterDataList
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    createMisFormField: (data) => { dispatch(createMisFormField(data)) },
    getMisFormFieldFilteredList: (data) => { dispatch(getMisFormFieldFilteredList(data)) },
    getMasterData:()=>{dispatch(getMasterData())}
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(MisFormFieldComponent));
